import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import styles from "./AuthLayout.module.css";
import HeroTree from "./HeroTree";
import AnimatedTagline from "./AnimatedTagline";
import { getActiveSeasonalTheme } from "./seasonal/seasonalTheme";
import {
  HalloweenPageDecor,
  HalloweenTreeDecor,
  HalloweenCardDecor,
} from "./seasonal/HalloweenDecor";
import {
  ThanksgivingPageDecor,
  ThanksgivingCardDecor,
} from "./seasonal/ThanksgivingDecor";

// TOCA mark, Figma node 1791:24435: five equal dots in a plus, exact geometry.
const TocaIcon = ({ size = 40 }) => (
  <svg
    viewBox="0 0 42 42"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <circle cx="20.9314" cy="5.63546" r="5.63534" />
    <circle cx="5.63534" cy="20.9316" r="5.63534" />
    <circle cx="20.9314" cy="20.9316" r="5.63534" />
    <circle cx="36.2273" cy="20.9316" r="5.63534" />
    <circle cx="20.9314" cy="36.2274" r="5.63534" />
  </svg>
);

const AuthLayout = ({ children }) => {
  const { pathname, search } = useLocation();

  // SCRUM-922 / SCRUM-933: seasonal theme on the Sign in screen only. null
  // (outside every date window, or any other auth screen) renders the
  // standard layout.
  const theme = useMemo(
    () => (pathname === "/login" ? getActiveSeasonalTheme(search) : null),
    [pathname, search]
  );
  const isHalloween = theme === "halloween";
  const isThanksgiving = theme === "thanksgiving";

  return (
    <div className={styles.root}>
      <div className={styles.heroSide}>
        <div className={styles.logoTL}>
          <img
            src="/assets/images/th_logo.svg"
            alt="TOCA Health"
            className={styles.logoImg}
          />
        </div>
        <HeroTree className={styles.treeAnim} />
        {isHalloween && <HalloweenTreeDecor treeClassName={styles.treeAnim} />}
        <div className={styles.taglineBL}>
          <AnimatedTagline />
        </div>
      </div>
      {isHalloween && <HalloweenPageDecor />}
      {isThanksgiving && <ThanksgivingPageDecor />}
      <div className={styles.cardSide}>
        <div className={styles.card}>
          {isHalloween && <HalloweenCardDecor />}
          {isThanksgiving && <ThanksgivingCardDecor />}
          <div className={styles.cardBadge}>
            <TocaIcon size={42} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
